module.exports = __webpack_public_path__ + "img/16.5-gallery.89624c0e.jpg";